import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Card, Button, Dialog, CircularProgress, Stack, Chip } from '@mui/material';
import Tree from 'rc-tree';
import '../../css/rc-tree.css';
import IndustriesService from '../../services/search-purchases-services/IndustriesService';

export function IndustrySelection(props) {

  useEffect(() => {
    if (props.openIndustrySelectionModal){
      props.onInitialLoad();
    }
  }, [props.openIndustrySelectionModal])

  return (
    <React.Fragment>
      <Dialog 
        open={props.openIndustrySelectionModal} 
        onClose={props.onCloseIndustrySelection}
        maxWidth="80%"
        PaperProps={{sx: {
          width: "1300px",
          //height: "620px",
          display: 'flex',
          flexDirection:'column',
          justifyContent: 'space-between',
          gap:'20px', 
          paddingTop:'10px',
        }}}
      >
        <Card sx={{overflowY: "auto", height: "550px"}}>
          {props.isLoading 
            ?
              <CircularProgress/>
            :
              <Tree
                checkable
                treeData={props.IndustryCodes}
                checkedKeys={props.checkedIndustryCodes.map(code => { return code.key; })}
                onCheck={props.onSetCheckedIndustryCodes}
                showIcon={false}
                className="highlighted"
              />
          }
        </Card>
        <Stack marginTop={'10px'} direction="row" /* spacing={1}*/ flexWrap="wrap" sx={{overflowY: "auto", maxHeight: "200px"}}>
          { props.checkedIndustryCodes.map((industry, key) =>
              <Chip sx={{ ml: 1, mt: 1 }} label={industry.title} key={key} onDelete={() => props.onRemoveSingleIndustrySelection(industry.key)}/>
          ) }
        </Stack>
        <Button onClick={() => props.onIndustriesSelected(props.checkedIndustryCodes, props.currentPage)}>Выбрать</Button>
      </Dialog>
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    IndustryCodes: state.industriesState.IndustryCodes,
    checkedIndustryCodes: state.industriesState.checkedIndustryCodes,
    openIndustrySelectionModal: state.industriesState.openIndustrySelectionModal,
    isLoading: state.industriesState.isLoading,
    searchWarningMessage: state.industriesState.searchWarningMessage,
    currentPage: state.pagesState.currentPage
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onInitialLoad: () => {
      IndustriesService.getIndustries()
        .then((result) => {
          const action = {
            type: 'INDUSTRIES_INITIATED',
            IndustryCodes: result
          };
          dispatch(action);
        })
        .catch((error) => {
          const notificationAction = {
            type: 'SNACKBAR_NOTIFICATION_SENT',
            notification: {
              message: 'Произошла ошибка при получении списка отраслей',
              variant: 'error'
            }
          };
          dispatch(notificationAction);
        });;
    },
    onSetCheckedIndustryCodes: (checkedIndustryCodes, event) => {
      const action = {
        type: 'INDUSTRY_CODE_CHECKED',
        checkedIndustryNodesPositions: event.checkedNodesPositions,
        checkedNode: event.node,
      };
      dispatch(action);
    },
    onIndustriesSelected: (checkedIndustryCodes, currentPage) => {
      const action = {
        type: 'INDUSTRIES_SELECTION_COMPLETED',
        checkedIndustryCodes: checkedIndustryCodes,
        currentPage: currentPage
      };
      dispatch(action);
    },
    onCloseIndustrySelection: () => {
      const action = {
        type: 'INDUSTRIES_SELECTION_CLOSED'
      };
      dispatch(action);
    },
    onRemoveSingleIndustrySelection: (key) => {
      const action = {
        type: 'SINGLE_SELECTED_INDUSTRIES_REMOVED',
        key: key
      };
      dispatch(action);
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IndustrySelection)

